export const translate: (key: string) => string = (key: string) => key;
